import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';
import { selectPortfolioSummaryAggregatedDataDrillDown } from 'widgets/portfolioSummary/store/data/selectors';
import { createUpdatePortfolioSummaryComponentStateAction } from 'widgets/portfolioSummary/store/instances/component/actions';
import { WidgetSetComponentAction } from 'widgets/store/component/actions';
import {
    PortfolioSummaryComponentState,
    PortfolioSummaryDrillDown,
} from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';
import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';

export const drilldownAsync =
    (
        widgetKey: string,
        aggregationField: AggregationField,
        drillDown: PortfolioSummaryDrillDown
    ) =>
    async (
        dispatch: ThunkDispatch<
            WidgetSetComponentAction<PortfolioSummaryComponentState>
        >,
        getState: () => State,
        { portfolioSummaryDataService }: Services
    ) => {
        const state = getState();
        dispatch(
            createUpdatePortfolioSummaryComponentStateAction(widgetKey, {
                drillDown,
            })
        );

        const drillDownData = selectPortfolioSummaryAggregatedDataDrillDown(
            state,
            aggregationField,
            drillDown
        );

        // If we have not already drilled down on this group, then need to do so...
        if (!drillDownData) {
            portfolioSummaryDataService.addDrilldown(
                aggregationField,
                drillDown
            );
        }
    };
